import { useOutletContext } from "react-router-dom";
import { useEffect } from "react";
import CustomerDashboard from "./Customer_Dashboard";
import DeliveryDashboard from "./Delivery_Dashboard";

const Dashboard = () => {
  const { setPageTitle } = useOutletContext();
  const loginUserType = localStorage.getItem("loginusertype");
  const title= loginUserType === "customer" ? "Dashboard - My Order" : "Dashboard"
  useEffect(() => {
    setPageTitle(title);
  }, [setPageTitle]);

  return (
    <>
      {loginUserType === "customer" ? (
        <CustomerDashboard />
      ) : (
        <DeliveryDashboard />
      )}
    </>
  );
};
export default Dashboard;
